<div class="row list-item-row border-bottom py-4" data-testing-id="product-list-item">
  <!-- Errors and Infos -->
  @if (pli().validationError?.message) {
  <div class="alert alert-inline alert-danger col-12">
    {{ pli().validationError.message }}
  </div>
  } @if (pli().info?.message) {
  <div class="alert alert-inline alert-info col-12">
    {{ pli().info.message }}
  </div>
  }
  <div class="col-10 col-md-6 col-xl-5">
    <div class="row">
      <div class="col-3 p-0 pl-1" [ngClass]="{ 'pl-0 pr-0': editable() }">
        <ish-product-image imageType="M" [link]="true" />
      </div>
      <div class="col-9">
        <!--Product Description -->
        <div class="pli-description">
          <ish-product-name [alternate]="pli().name" />

          <!-- Product ID -->
          <ish-product-id />

          <!-- Product Variations -->
          <ish-product-variation-display />
          <!-- Product Bundles -->
          <ish-product-bundle-display />

          <!-- switch by lineItemViewType -->
          @switch (lineItemViewType()) {
          <!-- lineItemViewType = 'simple' -->
          @case ('simple') { }
          <!-- lineItemViewType = 'availability' -->
          @case ('availability') {
          <ish-product-inventory />
          }
          <!-- default lineItemViewType -->
          @default {
          <!-- edit variation & quantity -->
          @if (editable()) { @if (!('preferences.ChannelPreferences.EnableAdvancedVariationHandling' |
          ishServerSetting)) {
          <ish-line-item-edit
            ishProductContext
            [sku]="pli().productSKU"
            [quantity]="pli().quantity.value"
            [itemId]="pli().id"
            (updateItem)="onUpdateItem($event)"
          />
          } }
          <!-- availability -->
          <ish-product-inventory />
          <!-- ship window message -->
          <ish-product-shipment />
          <!-- surcharges -->
          @for (surcharge of pli().itemSurcharges; track surcharge) {
          <div>
            {{ surcharge.displayName }} @if (!surcharge.displayName) {
            <span>{{ surcharge.text }}</span>
            }
            <span class="text-nowrap"> {{ surcharge.amount | ishPrice }} </span>
            <ng-template #SurchargeDescription> <span [innerHTML]="surcharge.description"></span> </ng-template>
            <a
              class="btn btn-link details-tooltip"
              [ngbPopover]="SurchargeDescription"
              [popoverTitle]="surcharge.displayName"
              placement="top"
            >
              {{ 'shopping_cart.detail.text' | translate }}
              <fa-icon [icon]="['fas', 'info-circle']" />
            </a>
          </div>
          } } }

          <!-- promotions -->
          @if (pli().valueRebates?.length) {
          <div>
            @for (rebate of pli().valueRebates; track rebate) {
            <ish-basket-promotion [rebate]="rebate" class="list-item-promo" />
            }
          </div>
          }
          <div class="d-flex mt-3 save-for-later">
            <div class="shopping-cart-icon">
              @if (editable()) {
              <ish-lazy-product-add-to-order-template
                [cssClass]="'btn-link btn-tool pl-0 add-to-order-template'"
                displayType="icon"
              />
              } @if (editable()) {
              <ish-lazy-product-add-to-wishlist
                [cssClass]="'btn-link btn-tool pl-0 add-to-wishlist'"
                displayType="icon"
              />
              }
            </div>

            @if (editable()) {
            <custom-lazy-product-add-to-save-for-later [basketLineItemId]="pli().id" />
            }
            <!-- <a
          class="btn-tool"
          *ngIf="!pli.isFreeGift && editable"
          [attr.data-testing-id]="'remove-line-item'"
          [attr.data-id]="pli.id"
          title="{{ 'shopping_cart.remove.item.button.label' | translate }}"
          (click)="onDeleteItem(pli.id)"
          >
          <fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
        </a> -->
          </div>
        </div>

        <!-- mobile quantity -->

        <div class="d-md-none mb-2">
          <span>{{ 'shopping_cart.price.heading' | translate }} : </span>
          <span> {{ pli().singleBasePrice | ishPrice }}</span>
        </div>

        <div class="quantity quantity-input-container d-xl-none">
          <div class="form-group">
            <span>
              <ish-product-quantity-label
                translationKey="shopping_cart.pli.qty.label"
                [for]="'pli-quantity_' + pli().position"
                class="col-form-label"
              />
              @if (editable()) {
              <ish-product-quantity [elementId]="'pli-quantity_' + pli().position" />
              } @else {
              {{ pli().quantity.value | number }}
              }
            </span>
          </div>
        </div>
        <div class="d-md-none">
          <!-- (Suggested) Total Price  -->
          <span> {{ 'shopping_cart.subtotal.dias.heading' | translate }} :</span>
          {{ pli().totals }}
          <span data-testing-id="total-price"> {{ pli().totals?.total | ishPrice }}</span>
        </div>
      </div>
    </div>
  </div>
  <!-- Product Image -->

  <!-- Prices -->
  <div class="col-md-3 d-none d-md-block pricing-container">
    <!-- (Suggested) Single Base Price  -->
    <div>
      {{ pli().singleBasePrice | ishPrice }}
    </div>
    <!-- Undiscounted single price -->
    @if (oldPrice) {
    <div class="old-price">
      <span class="price-value">{{ oldPrice | ishPrice }}</span>
    </div>
    }
  </div>

  <!-- desktop quantity -->
  <div class="col-2 col-xl-1 d-none d-xl-flex">
    <div class="form-group w-100 text-right" [ngClass]="{ 'pr-2': !editable() }">
      <label class="d-xl-none col-form-label">{{ 'shopping_cart.pli.qty.label' | translate }}</label>

      @if (editable()) {
      <ish-product-quantity [elementId]="'pli-quantity_' + pli().position" />
      } @else {
      {{ pli().quantity.value | number }}
      }
    </div>
  </div>
  @if (pli().totals) {
  <div class="col-3 col-md-2 total-price-display">
    <div>
      <!-- (Suggested) Total Price  -->

      <div data-testing-id="total-price">{{ pli().totals.total | ishPrice }}</div>
    </div>
    <!-- Value Rebates Total -->
    @if (pli().totals.valueRebatesTotal) {
    <div class="old-price">
      <span class="price-value">{{ pli().totals.undiscountedTotal | ishPrice }}</span>
    </div>
    }
    <!-- Gift -->
    @if (pli().isFreeGift) {
    <div class="list-item-promo">{{ 'checkout.pli.freegift.text' | translate }}</div>
    }
  </div>
  }

  <!-- Action tab -->
  @if (!pli().isFreeGift && editable()) {
  <div class="col-2 col-md-2 col-xl-1 text-right shopping-cart-action" [ngClass]="{ 'pr-0': editable() }">
    <span>
      <custom-edit-line-item [pli]="pli()" [icon]="['fas', 'pencil']" />
    </span>
    <span>
      @if (!pli().isFreeGift && editable()) {
      <a
        [attr.data-testing-id]="'remove-line-item'"
        [attr.data-id]="pli().id"
        title="{{ 'shopping_cart.remove.item.button.label' | translate }}"
        (click)="onDeleteItem(pli().id)"
        data-inline="true"
      >
        X
      </a>
      }</span
    >
  </div>
  }
  <!-- display/select warranty if available -->
  <div class="col-sm-12">
    <ish-line-item-warranty [pli]="pli()" [editable]="editable()" />
  </div>
</div>
